module.exports = __webpack_public_path__ + "img/mk-video-poster.697ca6cf.jpg";